import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 30, className = "", amount = 0.15 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.85, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.15, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`font-mono text-[11px] uppercase tracking-[0.32em] text-aqua font-medium ${className}`}>
      {children}
    </p>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-aqua/10 py-7 bg-deep/30" data-testid="marquee">
      <div className="flex w-max animate-marquee items-center">
        {row.map((t, i) => (
          <span
            key={i}
            aria-hidden={i >= items.length}
            className="flex items-center gap-12 pr-12 whitespace-nowrap font-mono text-xs md:text-sm uppercase tracking-[0.4em] text-foam/40"
          >
            {t}
            <svg width="14" height="14" viewBox="0 0 40 40" fill="none" className="shrink-0">
              <path
                d="M20 4C20 4 8 18 8 26C8 32.6 13.4 38 20 38C26.6 38 32 32.6 32 26C32 18 20 4 20 4Z"
                stroke="#38BDF8"
                strokeOpacity="0.55"
                strokeWidth="2"
              />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
